/**
 * A small code snippet showing the real operation behind the slide.
 *
 * These are meant to be read in about five seconds, so they show the actual
 * calls this app makes rather than pseudocode.
 */

import { cn } from "@/lib/utils";
import { CopyButton } from "./HashDisplay";

export function CodeBlock({
  code,
  caption,
  className,
}: {
  code: string;
  caption?: string;
  className?: string;
}) {
  const trimmed = code.replace(/^\n/, "").replace(/\n\s*$/, "");

  return (
    <div className={cn("rounded-lg border bg-zinc-950 text-zinc-100 dark:bg-zinc-900", className)}>
      <div className="flex items-center justify-between border-b border-white/10 px-3 py-1.5">
        <span className="text-xs font-medium text-zinc-400">{caption ?? "code"}</span>
        <CopyButton value={trimmed} label="code" />
      </div>
      <pre className="overflow-x-auto px-3 py-2.5 font-mono text-xs leading-relaxed">
        <code>{trimmed}</code>
      </pre>
    </div>
  );
}

/** Decoded manifest shown as JSON, beside the bytes it encodes to. */
export function JsonBlock({ value, caption }: { value: unknown; caption?: string }) {
  const json = JSON.stringify(value, null, 2);

  return (
    <div className="rounded-lg border bg-muted/30">
      <div className="flex items-center justify-between border-b px-3 py-1.5">
        <span className="text-xs font-medium text-muted-foreground">{caption ?? "decoded"}</span>
        <CopyButton value={json} label="JSON" />
      </div>
      <pre className="overflow-x-auto px-3 py-2 font-mono text-xs leading-relaxed">
        <code>{json}</code>
      </pre>
    </div>
  );
}
